import { CSSObject } from '@emotion/react';
import {
    HoneycombTheme,
    ResponsiveStyleValue,
    SpacingValue,
    createResponsiveStyles,
    mergeResponsiveStyleValues,
    useHoneycombTheme,
} from '../../theming';

function getSpacingStyles(theme: HoneycombTheme) {
    return (value: { columnSpacing: SpacingValue; rowSpacing: SpacingValue }): CSSObject => {
        const { columnSpacing, rowSpacing } = value;
        return {
            columnGap: theme.fn.getSpacingValue(columnSpacing),
            rowGap: theme.fn.getSpacingValue(rowSpacing),
        };
    };
}
export interface StackerStylesParams {
    columnSpacing?: ResponsiveStyleValue<SpacingValue>;
    rowSpacing?: ResponsiveStyleValue<SpacingValue>;
}

type StyleClasses = 'root';

export function useStyles({ columnSpacing, rowSpacing }: StackerStylesParams): {
    styles: { [key in StyleClasses]: CSSObject };
} {
    const { theme } = useHoneycombTheme();

    const root: CSSObject = {
        ...createResponsiveStyles(
            [
                {
                    value: mergeResponsiveStyleValues({ columnSpacing, rowSpacing }, theme),
                    getStyles: getSpacingStyles(theme),
                },
            ],
            theme
        ),
        '& > *': {
            flexShrink: 0,
        },
    };

    return {
        styles: {
            root,
        },
    };
}
